<template>
  <div id="menu" :class="{show: $store.state.showMenu}" @click="hide">
    <router-link to="/home" class="item">
      <div class="icon">
        <svgicon src="svg/home.svg" :width="20" :height="20"></svgicon>
      </div>
      <div class="name">{{ $t("menu.home") }}</div>
      <svgicon class="arrow" src="svg/arrow.svg" :height="20" :width="20"></svgicon>
    </router-link>
    <router-link to="/account-creation" class="item" v-if="!User.token">
      <div class="icon">
        <svgicon src="svg/demande.svg" :width="20" :height="20"></svgicon>
      </div>
      <div class="name">{{ $t("menu.account_request") }}</div>
     <svgicon class="arrow" src="svg/arrow.svg" :height="20" :width="20"></svgicon>
    </router-link>
    <router-link to="/news" class="item" v-if="User.token">
      <div class="icon">
        <svgicon src="svg/speaker.svg" :width="20" :height="20"></svgicon>
      </div>
      <div class="name">{{ $t("menu.news") }}</div>
      <svgicon class="arrow" src="svg/arrow.svg" :height="20"  :width="20"></svgicon>
    </router-link>
    <router-link to="/services" class="item" v-if="Services && Services.services.length > 0 && Services.categories.length > 0">
      <div class="icon">
        <svgicon src="svg/services.svg" :width="20" :height="20"></svgicon>
      </div>
      <div class="name">{{ $t("menu.services") }}</div>
      <svgicon class="arrow" src="svg/arrow.svg" :height="20" :width="20"></svgicon>
    </router-link>

    <template v-if="User.token">
      <router-link to="/billboard" class="item">
        <div class="icon">
          <svgicon src="svg/news.svg" :width="20" :height="20"></svgicon>
        </div>
        <div class="name">{{ $t("menu.billboard") }}</div>
        <svgicon class="arrow" src="svg/arrow.svg" :height="20" :width="20"></svgicon>
      </router-link>
      <router-link to="/requests" class="item" v-if="RequestCategories && RequestCategories.categories.length > 0">
        <div class="icon">
          <svgicon src="svg/history.svg" :width="20" :height="20"></svgicon>
        </div>
        <div class="name">{{ $t("menu.requests") }}</div>
        <svgicon class="arrow" src="svg/arrow.svg" :height="20" :width="20"></svgicon>
      </router-link>
      <router-link to="/bookings" class="item" v-if="Services && Services.services.length > 0 && Services.categories.length > 0">
        <div class="icon">
          <svgicon src="svg/date.svg" :width="20" :height="20"></svgicon>
        </div>
        <div class="name">{{ $t("page.bookings") }}</div>
        <svgicon class="arrow" src="svg/arrow.svg" :height="20" :width="20"></svgicon>
      </router-link>
      <router-link to="/documents" class="item">
        <div class="icon">
          <svgicon src="svg/folder.svg" :width="20" :height="20"></svgicon>
        </div>
        <div class="name">{{ $t("menu.documents") }}</div>
        <svgicon class="arrow" src="svg/arrow.svg" :height="20" :width="20"></svgicon>
      </router-link>
    </template>

    <ExternalLink class="item" :url="urlIshop" v-if="!$store.state.cogir">
      <div class="icon">
        <svgicon src="svg/order.svg" :width="20" :height="20"></svgicon>
      </div>
      <div class="name">{{ $t("menu.order") }}</div>
      <svgicon class="arrow" src="svg/arrow.svg" :height="20" :width="20"></svgicon>
    </ExternalLink>
    <router-link to="/profile" class="item" v-if="User.token">
      <div class="icon">
        <svgicon src="svg/user.svg" :width="20" :height="20"></svgicon>
      </div>
      <div class="name">{{ $t("menu.profile") }}</div>
      <svgicon class="arrow" src="svg/arrow.svg" :height="20" :width="20"></svgicon>
    </router-link>
    <router-link to="/about" class="item">
      <div class="icon">
        <svgicon src="svg/humaniti.svg" :width="20" :height="20" v-if="!$store.state.cogir"></svgicon>
        <img src="@/assets/img/icons/octo.png" class="cogir" v-if="$store.state.cogir" height="20">
      </div>
      <div class="name">{{ $store.state.cogir ? $t('menu.about_cogir') : $t('menu.about') }}</div>
      <svgicon class="arrow" src="svg/arrow.svg" :height="20" :width="20"></svgicon>
    </router-link>
    <router-link to="/locale" class="item">
      <div class="icon">
        <svgicon src="svg/locale.svg" :width="20" :height="20"></svgicon>
      </div>
      <div class="name">{{ $t("menu.locale") }}</div>
      <svgicon class="arrow" src="svg/arrow.svg" :height="20" :width="20"></svgicon>
    </router-link>
    <router-link to="/login" class="item" v-if="!User.token">
      <div class="icon">
        <svgicon src="svg/user.svg" :width="20" :height="20"></svgicon>
      </div>
      <div class="name">{{ $t("menu.login") }}</div>
      <svgicon class="arrow" src="svg/arrow.svg" :height="20" :width="20"></svgicon>
    </router-link>
  </div>
</template>

<script>

  import User from '../../core/User';
  import Services from '../../core/Services';
  import RequestCategories from '../../core/RequestCategories';
  import { mapActions } from 'vuex';
  import ExternalLink from "./ExternalLink";

  export default {

    name: "menuComponent",

    components: { ExternalLink },

    data() {
      return {
        User,
        Services,
        RequestCategories,
        storedTitle: null,
        urlIshop: this.$store.state.cogir ? '' : 'https://web.ishopfood.com/#/humaniti/h3/menu'
      };
    },

    watch: {
      "$store.state.showMenu"(newValue) {
        if (newValue) {
          this.storedTitle = this.$store.state.headerTitle;
          this.$store.state.headerTitle = "menu.our_application";
        } else if (this.$store.state.headerTitle == "menu.our_application" && this.storedTitle) {
          this.$store.state.headerTitle = this.storedTitle;
        }
      }
    },

    methods: {
      ...mapActions(["openBrowser"]),

      hide() {
        this.$store.state.showMenu = false;
      },
      logout() {
        User.logout();
        this.$router.push("/login");
      },
    }

  }

</script>

<style lang="scss" scoped>

  #menu {
    position: fixed;
    top: 60px;
    bottom: 0;
    left: 0;
    right: 0;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.1s ease;
    background-color: rgba(#001722, 0.75);
    display: flex;
    flex-direction: column;

    &.show {
      pointer-events: all;
      opacity: 1;
    }
  }

  .item {
    flex-grow: 1;
    color: white;
    text-transform: uppercase;
    border-bottom: 1px solid #405159;
    display: flex;
    align-items: center;
    padding: 0 40px;
    max-height: 70px;

    .icon {
      width: 20px;
      height: 20px;
      margin-right: 20px;
      display: flex;
      justify-content: center;
      align-items: center;

      .svgicon {
        fill: #808b91;
      }

      img {
        max-width: 20px;
        max-height: 20px;
      }
    }

    .arrow {
      fill: #808b91;
    }

    .name {
      flex-grow: 1;
    }
  }

</style>
